import { Colors, Fonts } from '../../../shared/theme/';
import metrics from '../../../shared/theme/metrics';
import { textStyles } from '../../../shared/theme/fonts-ppv';

export default {
  defaultContent: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
    gap: 'clamp(12px, 2vw, 24px)',
    backgroundColor: Colors.grey50,
    maxWidth: '1280px',
    width: '100%',
    justifySelf: 'center',
  } as React.CSSProperties,
  cardBox: {
    marginTop: '24px',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row'
  } as React.CSSProperties,
  cardSuccess: {
    height: '126px',
    width: '100%',
  } as React.CSSProperties,
  cardBody: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: 0,
    paddingTop: 16,
    border: 'none',
  },
  card: {
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '16px',
    paddingLeft: '16px',
    overflow: 'clip'
  },
  titleBox: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'clamp(8px, 1.5vw, 16px)',
    padding: 'clamp(12px, 2vw, 16px)'
  },
  imageBox: {
    width: '100%',
    height: 100
  },
  buttonBox: {
    marginTop: '56px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '300px'
  },
  titleContent: {
    ...textStyles.subtitle1,
    fontSize: 'clamp(16px, 2vw, 24px)',
    color: Colors.secondary,
    whiteSpace: 'wrap',
    textAlign: 'start',
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 'clamp(12px, 2vw, 24px)',
  },
  martImage: {
    width: '800px',
    marginTop: metrics.baseMargin * 2.5
  }
};
